/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FornecedoresTable from '../TabelaFornecedores';
import * as S from './styles'
import { getAllModels } from '../../services/models';
import { ModalConfirm } from '../ModalConfirm';
import { Typography } from '@material-ui/core';
import { deleteSupplier } from '../../services/fornecedores';
import { toast } from 'react-toastify';


export default function DialogFornecedores({ openDialog = false, setOpenDialog }) {
  const [groups, setGroups] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [searchSubGroup, setSubSearchGroup] = useState('');
  const [searchDoc, setSearchDoc] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    initialRequest()
  }, [])

  useEffect(() => {
    if (searchGroup) {
      setSubGroups(groups.find(s => s.ID == searchGroup).SUBGRUPOS)
    }
  }, [searchGroup, groups])

  async function initialRequest() {
    const data = await getAllModels('grupos')
    setGroups(data.data)
  }

  function handleClose() {
    setSearchName('');
    setSearchGroup('');
    setSubSearchGroup('');
    setSearchDoc('');
    setOpenDialog(false);
    setOpenDeleteModal(false);
    setIsLoadingDelete(false);
    setSelectedSupplier(null);
  }

  function handleSelectSupplier(supplier) {
    setOpenDeleteModal(true);
    setSelectedSupplier(supplier);
  }

  async function handleDeleteSupplier() {
    setIsLoadingDelete(true);
    try {
      await deleteSupplier(selectedSupplier.ID);
      toast('Fornecedor excluído com sucesso!', {
        position: 'bottom-right',
        hideProgressBar: true,
      });
      setRefreshKey(prev => prev + 1); // Atualiza a tabela após exclusão
    } catch (e) {
      toast('Erro ao excluir fornecedor!', {
        position: 'bottom-right',
        hideProgressBar: true,
      });
    } finally {
      setIsLoadingDelete(false);
      setOpenDeleteModal(false);
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        scroll="paper"
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <S.DialogHeader>

          <DialogTitle id="max-width-dialog-title">
            <p style={{
              color: "#000000", fontSize: '1.25rem',
              fontWeight: 'bold', textAlign: 'start'
            }}
              component="h1" variant="subtitle1">
              Fornecedores
            </p>

          </DialogTitle>
          <S.Input placeholder="Nome" onChange={({ target }) => setSearchName(target.value)} />

          <S.Select onChange={(e) => setSearchGroup(e.target.value)}>
            <option value="">Selecione um grupo</option>
            {groups?.length > 0 && groups.map(({ ID, NOME }) => (<option key={ID} value={ID}>{NOME}</option>))}
          </S.Select>

          <S.Select onChange={(e) => setSubSearchGroup(e.target.value)}>
            <option value="">Selecione um subgrupo</option>
            {subGroups?.length > 0 && subGroups.map(({ ID, SUB_GRUPO }) => (<option key={ID} value={ID}>{SUB_GRUPO}</option>))}
          </S.Select>

          <S.Select onChange={(e) => setSearchDoc(e.target.value)}>
            <option value="">Status dos documentos</option>
            <option value="Tudo certo">Tudo certo</option>
            <option value="Vencido">Vencidos</option>
            <option value="Incompleto">Incompletos</option>
          </S.Select>
        </S.DialogHeader>
        <DialogContent>
          <FornecedoresTable
            searchName={searchName}
            searchGroup={searchGroup}
            searchSubGroup={searchSubGroup}
            searchDoc={searchDoc}
            onDeleteUser={handleSelectSupplier}
            refreshKey={refreshKey}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <ModalConfirm
        title="Excluir Fornecedor"
        message={<>
          <>

            Tem certeza que deseja excluir o fornecedor <b>{selectedSupplier?.NOME}</b>?<br />
            Esta ação <b>SERÁ IRREVERSÍVEL</b> e implicará na exclusão dos registros nas seguintes tabelas:

            <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 24 }}>
              <li>Certificados</li>
              <li>Contatos</li>
              <li>Documentos</li>
              <li>Arquivos</li>
              <li>Desafios</li>
              <li>Usuários</li>
            </ul>
          </>
        </>}
        isLoading={isLoadingDelete}
        isOpen={openDeleteModal}
        cancel={() => setOpenDeleteModal(false)}
        confirm={handleDeleteSupplier}
      />
    </>
  );
}